module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Item":"Artikel","Properties":"Attribute","Price":"Preis","Quantity":"Menge","Total":"Gesamt","Tax rate":"Steuersatz","Regular":"Regulär","Reduced":"Vermindert","Net amount to be credited":"Netto Gutschrift-Betrag","Gross amount to be credited":"Brutto Gutschrift-Betrag","Could not find anything":"Es konnte nichts gefunden werden","Comment":"Kommentar"}}')
  delete Component.options._Ctor
}
